import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmSiteSettingsProps } from '../../../../global/models/epi-model';
import { TcsmStates } from '../../../../root/tcsm-model';


interface Props {
    searchResultsRef: React.MutableRefObject<any>;
    showInternationalWarning: boolean;
    showDemographicWarning: boolean;
}

export function DocUploadToast(props: Props) {
    const { searchResultsRef, showInternationalWarning, showDemographicWarning } = props;
    const docUploadProps = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);

    let message = docUploadProps?.docUploadToastMessage;

    if (showDemographicWarning && showInternationalWarning){
        message = docUploadProps?.docUploadToastDemographicInternationalMessage || 'Documentation is required for an international address change and for a demographic change';
    }    

    if (!showDemographicWarning && showInternationalWarning){
        message = docUploadProps?.docUploadToastInternationalMessage || 'Documentation is required for an international address change';
    }

    const anchorText = docUploadProps?.docUploadAnchorText;
    const anchorIndex = message.indexOf('{anchor}');
    message = message.replace('{anchor}', '');    

        return (
        <>
            <p>
                {message.substring(0, anchorIndex === -1 ? message.length - 1 : anchorIndex)}
                <button className='alert-link-button paragraph' type='button' onClick={() => searchResultsRef.current.scrollIntoView({ behavior: 'smooth' })}>{anchorText}</button>
                {anchorIndex !== -1 ? message.substring(anchorIndex) : ''}
            </p>
        </>
    );
}